module.exports = __webpack_public_path__ + "img/2_character.22d5fdce.png";